import { forwardRef, useContext } from 'react'
import { ChipsContext } from './chips-context'
import { ChipsButtonContainer } from '../styled-components'

const ChipsButton = forwardRef(
  ({ children, onClick: customClick, ...props }, fowardedRef) => {
    const handleClick = (event) => {
      event.stopPropagation()
      if (customClick) {
        customClick()
      }
    }

    const context = useContext(ChipsContext)

    return (
      <ChipsButtonContainer
        ref={fowardedRef}
        onClick={(event) => handleClick(event)}
        aria-selected={context.selected}
        {...props}
        {...context}
      >
        {children}
      </ChipsButtonContainer>
    )
  }
)

ChipsButton.displayName = 'ChipsButton'

export default ChipsButton
